import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useState } from "react";

/**
 * A brief on-load preloader: soft paper background, a single count from 00 → 41,
 * then a paper-curtain reveal. Lives ~2s.
 */
export default function Loader({ onDone }) {
    const [count, setCount] = useState(0);
    const [gone, setGone] = useState(false);

    useEffect(() => {
        const duration = 1600;
        const start = performance.now();
        let raf;
        const tick = (t) => {
            const p = Math.min(1, (t - start) / duration);
            const eased = 1 - Math.pow(1 - p, 3);
            setCount(Math.round(eased * 41));
            if (p < 1) raf = requestAnimationFrame(tick);
            else {
                setTimeout(() => {
                    setGone(true);
                    onDone && onDone();
                }, 320);
            }
        };
        raf = requestAnimationFrame(tick);
        return () => cancelAnimationFrame(raf);
    }, [onDone]);

    return (
        <AnimatePresence>
            {!gone && (
                <motion.div
                    key="loader"
                    initial={{ opacity: 1 }}
                    exit={{ y: "-100%" }}
                    transition={{ duration: 1.2, ease: [0.77, 0, 0.175, 1] }}
                    className="fixed inset-0 z-[80] bg-[color:var(--paper)] flex items-end justify-between px-6 sm:px-12 lg:px-16 pb-10"
                    data-testid="loader"
                >
                    <div className="font-sans text-[10px] uppercase tracking-[0.35em] text-neutral-500">
                        A memorial · loading
                    </div>
                    <div className="font-sans tabular text-6xl sm:text-8xl font-extralight text-neutral-950 leading-none">
                        {count.toString().padStart(2, "0")}
                        <span className="text-neutral-400">/41</span>
                    </div>
                    <div className="font-sans text-[10px] uppercase tracking-[0.35em] text-neutral-500 hidden sm:block">
                        For Danielle
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
